import { TPlainTextKey } from '../../../Translations';

export type ProgramTabKind = 'active' | 'upcoming' | 'graduated' | 'past';

export const programTabKinds: ReadonlyArray<ProgramTabKind> = [
  'active',
  'upcoming',
  'graduated',
  'past',
];

export const programTabLabel = (kind: ProgramTabKind): TPlainTextKey => {
  switch (kind) {
    case 'active':
      return 'Active';
    case 'upcoming':
      return 'Upcoming';
    case 'graduated':
      return 'Graduated';
    case 'past':
      return 'Past';
  }
};

export const programTabId = (kind: ProgramTabKind): string => `program-tab-${kind}`;

export const programTabPanelId = 'program-tab-panel';
